
    import './styles.scoped.css';
    export default {
  "breadcrumb-group": "awsui_breadcrumb-group_d19fg_7xdd6_93",
  "item": "awsui_item_d19fg_7xdd6_109",
  "breadcrumb-group-list": "awsui_breadcrumb-group-list_d19fg_7xdd6_122",
  "ellipsis": "awsui_ellipsis_d19fg_7xdd6_134",
  "icon": "awsui_icon_d19fg_7xdd6_144",
  "mobile": "awsui_mobile_d19fg_7xdd6_149",
  "mobile-short": "awsui_mobile-short_d19fg_7xdd6_162"
};
  